import { getFeatureFlag } from 'src/app/core/services/feature-flag-helpers';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { TWhiteLabel } from '../white-label.model';
import { isChosenColor } from './is-chosen-color';
import { resolvePrimary950 } from './resolve-primary-950';
import { DEFAULT_ORIGINAL_PRIMARY_COLORS } from './white-label-defaults.const';

export function resolveStoredPrimary950(whiteLabelData: TWhiteLabel): string {
  if (getFeatureFlag(EFeatureFlag.REBRAND)) {
    return resolvePrimary950(whiteLabelData);
  }

  if (isChosenColor(whiteLabelData.primary950, DEFAULT_ORIGINAL_PRIMARY_COLORS.primary950)) {
    return whiteLabelData.primary950;
  }

  return '';
}
